<template>
    <div class="i-date-picker">
        <ilabel :label="label" :required="required" />
        <!--  <date-picker lang="ru" :value="date" @input="(v)=>{onChange(v)}" :first-day-of-week="1" width="100%"/> -->
        <div class="fa fa-calendar" @click="opened?done():openDatePicker()" :class="{active:opened}"></div>
        <input :value="date" @focus="onFocus" @change="onChange" placeholder="Введите дату" v-mask="time?timeMask:dateMask" />
        <div class="date-picker" vs-if="opened" v-show-delay="opened">
            <div>
                <div class="days picker" ref="dayPicker" v-scroll="v=>handleScroll('day', v)">
                    <div class="item" :class="{selected:datetime.day === d}" v-for='d in (datetime.daysInMonth | 30)' @click="select({day:d})">{{d}}</div>
                </div>
                <div class="months picker" ref="monthPicker" v-scroll="v=>handleScroll('month', v)">
                    <div class="item" :class="{selected:datetime.month === idx+1}" v-for="(m,idx) in months" @click="select({month:idx+1})">{{m}}</div>
                </div>
                <div class="years picker" ref="yearPicker" v-scroll="v=>handleScroll('year', v)">
                    <div class="item" :class="{selected:datetime.year === year_start+y}" v-for='y in year_end-year_start' @click="select({year:year_start+y})">{{year_start+y}}</div>
                </div>
                <div class="hours picker" ref="hourPicker" v-if="time" v-scroll="v=>handleScroll('hour', v)">
                    <div class="item" :class="{selected:datetime.hour === h}" v-for='(i,h) in 24' @click="select({hour:h})">{{h}}</div>
                </div>
                <div class="minutes picker" ref="minutePicker" v-if="time" v-scroll="v=>handleScroll('minute', v)">
                    <div class="item" :class="{selected:datetime.minute === m}" v-for='(i,m) in 60' @click="select({minute:m})">{{m}}</div>
                </div>
            </div>
            <btn i='check' @press="done" style='width:97%;display:block;' />
        </div>
    </div>
</template>
<script>
//import DatePicker from 'vue2-datepicker';
//import moment from "moment";
import { DateTime } from 'luxon';
window.DateTime = DateTime;
export default {
    // components: { DatePicker },
    name: 'i-date-picker',
    props: {
        label: String,
        value: { type: [String, DateTime] },
        zone: { type: String, default: 'utc' },
        required: { type: Boolean, default: false },
        time: { type: Boolean, default: false },
        year_start: { type: Number, default: 1900 },
        year_end: { type: Number, default: 2090 },
    },
    mounted() {
        console.log(this.value);
        this.setDate(this.value);
    },
    methods: {
        handleScroll(t, e) {
            e.preventDefault();
            if (this.datetime.invalid) {
                this.datetime = DateTime.utc();
            }
            this.datetime = this.datetime[e.wheelDelta > 0 ? 'minus' : 'plus']({
                [t]: 1
            })
            this.setScrolls(this.datetime);
        },
        onFocus() {},
        setDate(value) {
            let { zone } = this;
            console.log(value)
            this.datetime = DateTime.fromISO(value, { zone });
        },
        select(selected) {
            let { time } = this;
            if (this.datetime.invalid) this.datetime = DateTime.utc();
            this.datetime = this.datetime.set(selected).set(time ? { milliseconds: 0, seconds: 0 } : { hours: 0, minutes: 0, milliseconds: 0, seconds: 0 });
            this.$emit('input', this.datetime.toISO());
            this.setScrolls(this.datetime);
        },
        openDatePicker() {
            let self = this;
            this.opened = true;
            let { datetime } = this;
            if (datetime.invalid) {
                datetime = DateTime.utc();
            }
            setTimeout(() => {
                self.setScrolls(datetime);
            }, 10)
        },
        setScrolls(datetime) {
            let { year_start } = this;
            let { day, month, year, daysInMonth, hour, minute } = datetime;
            let dYear = year - year_start;
            let coef = 0;
            this.$refs.dayPicker.scrollTop = (day - 1) * 22 - coef;
            this.$refs.monthPicker.scrollTop = (month - 1) * 22 - coef;
            this.$refs.yearPicker.scrollTop = (dYear - 1) * 22 - coef;
            if (this.time) {
                this.$refs.hourPicker.scrollTop = (hour) * 22 - coef;
                this.$refs.minutePicker.scrollTop = (minute) * 22 - coef;
            }

        },
        done() {
            this.opened = false;
            this.$emit('input', this.datetime.toISO());
        },
        closeDatePicker() {
            this.opened = false;
        },
        onChange(e) {
            let { zone, time,timeFormat,dateFormat  } = this;
            let newDate = DateTime.fromFormat(e.target.value, time ? timeFormat : dateFormat, { zone })

            if (newDate) {
                this.datetime = newDate;
                this.$emit('input', this.datetime.toISO());
            }

        }
    },
    data() {
        return {
            opened: false,
            datetime: DateTime.utc(),
            timeFormat: "dd/LL/yyyy hh:mm",
            dateFormat: "dd/LL/yyyy",
            timeMask: '99/99/9999 99:99',
            dateMask: '99/99/9999',
            months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        }
    },
    computed: {
        date() {
            let { zone, time, timeFormat, dateFormat } = this;
            if (this.datetime.invalid) return "";
            return this.datetime.toFormat(time ? timeFormat : dateFormat);
            //return this.datetime.setZone(zone).toFormat("dd-LL-yyyy HH-mm");
        }
    }
}
</script>
<style lang="css" scoped>
.i-date-picker * {
    user-select: none;
    box-sizing: border-box;
}

.i-date-picker {
    margin-bottom: 8px;
    display: block;
    width: 100%;
    position: relative;
}

.picker {
    display: inline-block;
    height: 140px;
    /*overflow-y: scroll;*/
    overflow-y: hidden;
    border: 1px solid lightgrey;
    padding: 60px 0;
    margin: 0;
    text-align: center;
    background: white;
    overflow-x: none;
    background: linear-gradient(#e6e6e6, white, #e6e6e6);
    transition: 0.2s all ease;
    /*scroll-behavior: smooth;*/
    scroll-behavior: auto;
    position: relative;
    box-sizing: border-box;
}

.date-picker:after {
    content: '';
    display: block;
    position: absolute;
    background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    border-top: 1px solid lightgrey;
    border-bottom: 1px solid lightgrey;
    width: 100%;
    left: 0;
    height: 24px;
    top: 64px;
    z-index: 99;
    pointer-events: none;
}

.picker.months {
    text-align: left;
}

.picker .item {
    padding: 2px 4px;
}

.picker .item:hover {
    /*background: whitesmoke;*/
    cursor: pointer;
}

.picker .item.selected {
    /*    background: lightgrey;

    outline:1px solid grey;*/
}

.date-picker {
    border: 1px solid lightgrey;
    border-radius: 4px;
    display: inline-block;
    background: whitesmoke;
    display: inline-block;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    margin-top: -1px;
    margin-left: 26px;
    position: absolute;
    z-index: 1000;
    transition: 0.2s all ease;
    height: 0;
    overflow: hidden;
    border-bottom-width: 0;
    border-top-width: 0;
    opacity: 0;
    padding: 3px;
}

.date-picker.shown {
    height: 181px;
    opacity: 1;
    border-bottom-width: 1px;
    border-top-width: 1px;
}

input {
    border-radius: 4px;
    border: 1px solid lightgrey;
    padding: 3px 8px 3px 8px;
    outline: none;
    width: calc(100% - 24px);
    box-sizing: border-box;
}

.fa-calendar {
    color: grey;
    cursor: pointer;
    padding: 4px;
    border-radius: 2px;
    display: block;
    float: left;
    margin-right: 2px;
}

.fa-calendar:hover,
.fa-calendar.active {
    background: lightgrey;
}
</style>